// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulbFilledSvg from "@fishx/icons-svg/es/asn/BulbFilled";
import FishxIcon from '../components/FishxIcon';

var BulbFilled = function BulbFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BulbFilledSvg
  }));
};

BulbFilled.displayName = 'BulbFilled';
export default React.forwardRef(BulbFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BulbFilled.js
// module id = 2127
// module chunks = 0